import { entityIdSchema, familyRoleSchema, personNameSchema } from '@baby-tracker/validation';
import { z } from 'zod';

import { successEnvelope } from './envelope.js';
import { API_BASE_PATH } from './routes.js';

export const ME_PATH = `${API_BASE_PATH}/me` as const;

/** Auth display names are owned by Better Auth, which does not apply our family-name limit. */
const accountNameSchema = z.string().min(1).max(255);

export const meUserSchema = z.object({
    id: entityIdSchema,
    name: accountNameSchema,
    email: z.email(),
});

export const meFamilySchema = z.object({
    id: entityIdSchema,
    name: personNameSchema,
    role: familyRoleSchema,
});

export const meSchema = z.object({
    user: meUserSchema,
    families: z.array(meFamilySchema),
});

export type Me = z.infer<typeof meSchema>;

export const meResponseSchema = successEnvelope(meSchema);
export type MeResponse = z.infer<typeof meResponseSchema>;
